import { FullStory, init } from "@fullstory/browser"

const fullStoryEnabled = () => {
  return document.querySelector("meta[name=fullstory]")?.content === "true"
}

init({
  orgId: import.meta.env.VITE_FULLSTORY_ORG_ID,
})

if (!fullStoryEnabled()) FullStory("shutdown")
